export const defaultUserId = "2"

export const userIdKey = "_w_userid"

export const simpleModeKey = "_w_simple_mode"
